import { Field, Select, TextArea } from "@nabble/ui";
import { DETAILS_MAX } from "../../../model/dataRequests";
import type { Outcome, RequestDrawerState } from "./useRequestDrawer";

const OUTCOME_OPTIONS = [
  { value: "DONE", label: "Done", hint: "We did what the person asked" },
  { value: "REJECTED", label: "Not granted", hint: "We can't do what the person asked" },
];

/** The outcome and the answer the person receives by email. */
export function AnswerFields({ drawer }: { drawer: RequestDrawerState }): React.JSX.Element {
  return (
    <>
      <Field label="Outcome">
        <Select value={drawer.outcome} onValueChange={(v) => drawer.setOutcome(v as Outcome)} options={OUTCOME_OPTIONS} />
      </Field>
      <Field label="Answer" help="The person receives this by email." error={drawer.textError ?? undefined}>
        <TextArea value={drawer.text} onChange={(e) => drawer.setText(e.target.value)} rows={5} maxLength={DETAILS_MAX} autoFocus />
      </Field>
    </>
  );
}
